import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { getAreaTeamList } from '../../redux';
const initialState = {
    areaTeamList: [],
    error: null,
    isLoading: false,
};
const areaTeamList = createReducer(initialState, (builder) => {
    builder
        .addCase(getAreaTeamList.request, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        // TODO: Add action type explicitly everywhere?
        //       TypeScript already knows the type at this point, and PhpStorm knows it.
        //       However, probably not all IDE can do this + It can be easier to review PRs.
        .addCase(getAreaTeamList.success, (state, action) => {
        state.areaTeamList = action.payload.data.map(({ team_id: id, name, }) => ({
            id,
            name,
        }));
        state.isLoading = false;
    });
});
export default areaTeamList;
